import React, { useState } from "react";
import ElectricityBillPay from "./ElectricityBillPay";
import GasBillpay from "./GasBillpay";
// import WaterBillPay from "./WaterBillPay";
import InsuranceBillPay from "./InsuranceBillPay";

const BillOffline = () => {
  const [activeTab, setActiveTab] = useState("bill");

  const tabs = [
    { label: "Bill", value: "bill", icon: "⚡" },
    { label: "Gas", value: "gas", icon: "🔥" },
    // { label: "Water", value: "water", icon: "💧" },
    { label: "Insurance", value: "insurance", icon: "🛡️" },
  ];

  return (
    <div className="w-full min-h-screen bg-gradient-to-br from-[#EEF2F8] via-[#F8FAFF] to-[#E6ECF5] p-4">

      {/* 🔹 MAIN CARD */}
      <div className="max-w-6xl mx-auto rounded-3xl p-6 backdrop-blur-xl bg-white/70 border border-white/40 shadow-[0_20px_60px_rgba(0,0,0,0.08)]">

        {/* 🔹 HEADER */}
        <div className="mb-6">
          <h2 className="text-2xl font-bold text-[#1F2A44]">
            Bill Payments
          </h2>
          <p className="text-sm text-gray-500">
            Manage and pay all your bills in one place
          </p>
        </div>

        {/* 🔹 TOP TABS */}
        <div className="flex gap-3 mb-8 flex-wrap">
          {tabs.map((tab) => (
            <button
              key={tab.value}
              onClick={() => setActiveTab(tab.value)}
              className={`group flex items-center gap-2 px-5 py-2.5 rounded-2xl text-sm font-semibold transition-all duration-300
              
              ${
                activeTab === tab.value
                  ? "bg-gradient-to-r from-[#12345A] to-[#1E4D8C] text-white shadow-lg scale-105"
                  : "bg-white text-gray-600 border border-gray-200 hover:border-[#12345A] hover:text-[#12345A] hover:shadow-md"
              }
              
              `}
            >
              <span className="text-base">{tab.icon}</span>
              {tab.label}
            </button>
          ))}
        </div>

          {activeTab === "bill" && <ElectricityBillPay />}
          {activeTab === "gas" && <GasBillpay />}
          {/* {activeTab === "water" && <WaterBillPay />} */}
          {activeTab === "insurance" && <InsuranceBillPay />}
 

      </div>
    </div>
  );
};

export default BillOffline;